export default __webpack_public_path__ + "static/CLUB-9-cc30e8a993a87eecd4b748eb37aca543.png";